import { render, staticRenderFns } from "./float-label.vue?vue&type=template&id=3409d4d0"
import script from "./float-label.vue?vue&type=script&lang=js"
export * from "./float-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports